import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface Transaction {
    transactionId: string;
    transactionDate: Date;
    stationNo: string;
    chargerNo: string;
    stationName: string;
    stationAddress: string;
    last4: string;
    currency: string;
    net: number;
    vat: number;
    gross: number;
}

export interface TokenState {
    token: string | null;
}

export interface ResultState {
    token: string | null;
    result: Transaction | null;
}

const initialState: ResultState = {
    token: null,
    result: null,
};

const resultSlice = createSlice({
    name: 'result',
    initialState,
    reducers: {
        setToken: (state, { payload }: PayloadAction<TokenState>) => {
            state.token = payload.token;
        },
        setResult: (state, { payload }: PayloadAction<ResultState>) => {
            state.result = payload.result;
        },
        resetResult: () => initialState,
    },
});

export const resultReducer = resultSlice.reducer;
export const { setResult, resetResult, setToken } = resultSlice.actions;
